/**
 * Left-column pitch — ported verbatim from mockup/app.jsx's <Login> left side.
 * Used by both the public landing page and the sign-in / sign-up screens.
 */
export function LandingPitch() {
  return (
    <>
      <div className="brand-mark">
        <span className="brand-dot" />
        <span className="brand-text">
          cdk<span className="brand-text-mute">/course</span>
        </span>
      </div>
      <div className="login-pitch">
        <div className="login-eyebrow">Advanced CDK</div>
        <h1 className="login-title">
          A practitioner&apos;s course on building production-grade
          infrastructure.
        </h1>
        <p className="login-sub">
          Twenty-nine chapters. Real-world patterns. None of the &ldquo;hello
          world and goodbye&rdquo; energy you get from the average tutorial.
        </p>
        <ul className="login-list">
          <li>
            <span className="login-li-dash">&mdash;</span> Stacks, stages, and
            the synthesis pipeline
          </li>
          <li>
            <span className="login-li-dash">&mdash;</span> Constructs you&apos;ll
            actually want to reuse
          </li>
          <li>
            <span className="login-li-dash">&mdash;</span> Testing strategy that
            holds up under change
          </li>
          <li>
            <span className="login-li-dash">&mdash;</span> CDK Pipelines and
            multi-account deploys
          </li>
        </ul>
      </div>
      <div className="login-foot">
        <span>29 chapters</span>
        <span className="login-foot-dot">·</span>
        <span>2h 20m of video</span>
      </div>
    </>
  );
}
